export default "__VITE_ASSET__Bmie$2oe__"